// extracted by mini-css-extract-plugin
export default {"range":"Title_range__HaXh1","popover":"Title_popover__VNZt+"};